import Route from '@ember/routing/route';
import { set, get } from '@ember/object';
import { service } from '@ember/service';

export default Route.extend({
  abilities: service(),
  fundsService: service(),
  navbarSettings: service(),
  store: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Delete Transaction');
    return this.fundsService.confirmValidFundToken();
  },

  model(params, transition) {
    return this.store.findRecord('line-item', params.id).then((line) => {
      // Can't edit non-manual transaction if you don't have the edit_all_transactions ability
      if (!line.isManual && this.abilities.noAbility('edit_all_transactions')) {
        transition.abort();
        return;
      }

      return {
        line,
      };
    });
  },

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.reset();
    }
  },
});
